export default "__VITE_ASSET__C0YhQQ8w__"